// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"style_mainWrapper__3YkMc","bodyContent":"style_bodyContent__1I2Yh"};